module.exports = __webpack_public_path__ + "media/brands/mg-dbf8f021.png";